import Assets from 'assets/icons';
import classNames from 'classnames';
import { RSidbarItem, RSidebarStack } from 'components/RightSideBar/RightSideBar';
import dayjs from 'dayjs';
import { i18n, TFunction } from 'i18next';
import { Dispatch, SetStateAction, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hook';
import mainClasses from '../../RightSideBar.module.scss';
import { getChatSettingData } from './datas';
import MemberController from './MemberController';
import classes from './ChatSettings.module.scss';
import fetchGroupsAndUsers from 'store/reducers/usersGroupCreator';
import { Avatar } from 'antd';

type Props = {
  stack: RSidebarStack[];
  setStack: Dispatch<SetStateAction<RSidebarStack[]>>;
  t: TFunction;
  i18n: i18n;
};

const ChatSettings = ({ stack, setStack, t, i18n }: Props) => {
  const { chatData, selectedChat } = useAppSelector((state) => state.chat);
  const { users, isGroupsAndUsersLoading, dataUserTable } = useAppSelector((state) => state.dataUsers);
  const { dataRoom } = useAppSelector((state) => state.dataRoom);
  const dispatch = useAppDispatch();
  const locale = i18n.language || 'en';

  useEffect(() => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const members: RSidbarItem[] = users
      // .filter(({ role }) => role as any === 'full_administrator')
      .map(({ first_name, last_name, email }) => ({
        name: `${first_name} ${last_name}`,
        type: 'user',
        content: email,
      }));

    const groupedData = chatData[selectedChat?.id!]?.grouped.flatMap((chat, index) =>
      chat
        .map((history) => {
          const urls = history.message.match(urlRegex);
          if (!urls) return null;

          return {
            name: history.message,
            type: 'link',
            url: urls[0],
            timestamp: history.created_at,
            isRenderTimestamp: index === 0,
          };
        })
        .filter(Boolean)
    ) as RSidbarItem[];
    
    const data = getChatSettingData(t, { links: groupedData?.length ? groupedData : [], members: members });    
    setStack([{ parent: data, children: data.children! }]);
  }, [selectedChat, users, locale, chatData, chatData[selectedChat?.id!]?.data?.length]);

  useEffect(() => {
    if (dataRoom?.id && !dataUserTable[0] && !isGroupsAndUsersLoading) {
      dispatch(fetchGroupsAndUsers({ room_id: dataRoom?.id }));
    }
    return () => {
      setStack([{parent: null, children: []}]);
    }
  }, [dataRoom?.id]);

  const enter = (item: RSidbarItem) => {
    if (item.children) {
      setStack([...stack, { parent: item, children: item.children }]);
    }

    if (item.type === 'link') {
      window.open(item.url);
    }
  };  

  return (
    <div className={classes.wrapper}>
      <div className={classNames(mainClasses.rSidebarContent, classes.baseline)}>
        {stack[stack.length - 1].children?.map((stackItem, idx) =>
          stackItem.type === 'divider' ? (
            <div key={`${stack[stack.length - 1].parent?.name}-item-${idx}`} className={classes.divider}>
              {stackItem.name}
            </div>
          ) : !stackItem?.exceptionKeys?.includes(selectedChat?.entity_type!) ? (
            <div key={`${stack[stack.length - 1].parent?.name}-item-${idx}`}>
              {stackItem.timestamp && (
                <div className={classes.divider}>{dayjs(stackItem.timestamp).format('DD MMMM YYYY')}</div>
              )}
              {stackItem.type === 'user' ? (
                <div className={classes.members_item} style={{padding: '10px'}}>
                  <div className={classes.avatarWrap}>
                    <Avatar className={classes.avatar}>
                      <span className={classes.avatarWord}>{stackItem.name[0]}</span>
                    </Avatar>
                  </div>
                  <div className={classes.info}>
                    {' '}
                    <div>{stackItem.name}</div>
                    <div>{stackItem.content}</div>
                  </div>
                </div>
              ) : (
                <div onClick={() => enter(stackItem)} className={mainClasses.buttonItem}>
                  {stackItem.icon && <div className={mainClasses.buttonPrefix}>{stackItem.icon}</div>}
                  <div className={classNames(mainClasses.buttonText, classes.ellipsis)}>{stackItem.name}</div>
                  <div
                    className={mainClasses.buttonPostfix}
                    style={{ width: '40px', display: 'flex', alignItems: 'center' }}
                  >
                    <span>{stackItem.count}</span> {stackItem.type === 'folder' && <Assets.RightIcon />}
                  </div>
                </div>
              )}
            </div>
          ) : null
        )}
      </div>

      {selectedChat && <MemberController chatInfo={selectedChat!} t={t} />}
    </div>
  );
};

export default ChatSettings;
